export const blackListWindowReferrerRegexp = /aone[0-9]+.com/;

export const blackListWindowNames: string[] = ['datacont1'];
